<template>
  <v-dialog v-model="config.open" max-width="355" :persistent="persistent" >
    <v-card>
      <v-card-title class="headline">{{titulo}}</v-card-title>
      <v-form v-model="dObs" ref="formdObs">
      
        <v-layout row wrap>
          <v-flex xs12 sm12 md12 p-t-20>
            <v-select
              v-model="config.motivoSelecionado"
              :items="listaMotivos"
              item-text="mtMotivo"
              item-value="mtNumero"
              clearable
              class="custom-select"
              :menu-props="{ offsetY: true, minWidth: '300px', left: true }"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout wrap p-b-10>
          <v-flex xs12 sm6>
            <v-btn @click="$emit('observacaoCancel')">{{labelBtnCancelar}}</v-btn>
          </v-flex>
          <v-flex xs12 sm6>
            <v-btn color="info" @click="observacaoOk()" :loading="isLoading">{{labelBtnOk}}</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import ValidacaoBase from "../plugins/js/ValidacaoBase";
import DocumentosFornecService from "../services/documentosFornecService";
import FamiliaService from "../services/familiaService";
import Vue from 'vue';
export default {
  mixins: [ValidacaoBase],
  props: {//Propriedades que o objeto recebe como parametro
    rules:Array,
    persistent:Boolean,
    config: {
      type: Object,
      default: function() {
        return {
          open: false,
          titulo: "Motivo de Indeferimento",
          obs: null,
          labelBtnCancelar: "Cancelar",
          labelBtnOk: "Rejeitar",
          motivoSelecionado: null,
          codDocumento: null,
          codGrupo: null,
          numFamilia: null

        };
      }
    },
  },
  data() {//Declaracao de variaveis
    return {
      dObs: true,
      isLoading: false,
      listaMotivos: [],
    };
  },
  created() /*Metodo de start do componente*/{

    this.carregarListaMotivos();

  },
  computed: {//Campos computados
    titulo: function() {
      return (this.config.titulo === this.config.titulo
        ? this.config.titulo
        : "Motivo de Indeferimento");
    },
    labelBtnCancelar: function() {
      return this.config.labelBtnCancelar ? this.config.labelBtnCancelar : "Cancelar";
    },
    labelBtnOk: function() {
      return this.config.labelBtnOk ? this.config.labelBtnOk : "Rejeitar";
    },
     _rules: function() {
      return this.rules ? this.rules : this.validacao.campoObrigatorio;
    },
  },
  watch: { //Propriedades assistidas
    "config.open": {
      handler(newValue, oldValue) {
        if (!newValue) {
          this.isLoading = false;
        }
      }
    },
    "config.codDocumento": {
      handler(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          this.carregarListaMotivos();
        }
      }
    },
    "config.codGrupo": {
      handler(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          this.carregarListaMotivosFamilia();
        }
      }
    },
    "config.numFamilia": {
      handler(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          this.carregarListaMotivosFamilia();
        }
      }
    },
  },

  methods: {//Declaracao de todos os metodos
    observacaoOk() {
      if (this.config.motivoSelecionado != null) {
        this.isLoading = true;
        this.$emit("observacaoOk");
      }
      else
      {
        Vue.toasted.error(this.$t("messages.validacao.motivoIndeferimento"));
      }
    },
    carregarListaMotivosFamilia(){
      //Se o grupo e numero da familia estão preenchidos
      if (this.config.codGrupo && this.config.numFamilia)
      {
        FamiliaService.getMotivosIndeferimento(this.config.codGrupo,this.config.numFamilia).then(response => { /*resposta do servico*/
          this.listaMotivos = response.data; /*dados de retorno*/
        });
      }
    },
    carregarListaMotivos(){
      if (this.config.codDocumento)
      {
        DocumentosFornecService.getMotivosIndeferimento(this.config.codDocumento).then(response => { /*resposta do servico*/
          this.listaMotivos = response.data; /*dados de retorno*/
        });
      }
    },
  }
};
</script>

<style scoped>
.v-select {
  max-width: 300px; /* Ajuste esse valor conforme necessário */
}

.v-select .v-list-item__title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>